import Map from '../components/Map';

export default function Guide() {
  return (
    <div>
      <Map />
    </div>
  );
}